import { axios } from '@Root/API'

export const create = (studyProgrammeId, payload) => {
	return axios.post(`program/${studyProgrammeId}/curriculum-accreditation`, payload)
}
